import React from 'react';

const Location = (props: object) => {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.39701 8.15365C7.47545 8.15365 8.34969 7.2794 8.34969 6.20097C8.34969 5.12254 7.47545 4.24829 6.39701 4.24829C5.31858 4.24829 4.44434 5.12254 4.44434 6.20097C4.44434 7.2794 5.31858 8.15365 6.39701 8.15365Z"
        stroke="currentColor"
      />
      <path
        d="M1.15193 5.06182C2.38487 -0.358112 10.4146 -0.351853 11.6413 5.06808C12.3611 8.24744 10.3833 10.9386 8.64972 12.6034C7.39174 13.8176 5.40151 13.8176 4.13728 12.6034C2.40991 10.9386 0.432194 8.24118 1.15193 5.06182Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Location;
